define.alias("shared/utils/number-helpers/is-in-range", "media/utils/number-helpers/is-in-range");